import React, { useState } from "react";
import { useSelector } from "react-redux";
import ChoosePaymentType from "./choosePaymentType";

export default function ChoosePlan() {
  const investmentReducer = useSelector((state) => state.investmentReducer);
  const getInvestmentDetails = investmentReducer ? investmentReducer.plans : "";
  const [investmentType, setinvestmentType] = useState("");
  const handlePlanChoose = (plansDetails) => {
    setinvestmentType(plansDetails);
  };

  console.log(investmentType);
  return (
    <div>
      <div class="plan_investment_wrapper float_left">
        <div class="row">
          <div class="col-md-12 col-lg-12 col-sm-12 col-12">
            <div class="sv_heading_wraper">
              <h3>plan details</h3>
            </div>
          </div>
          {investmentType ? (
            <ChoosePaymentType inestmentAmount={{ ...investmentType }} />
          ) : getInvestmentDetails ? (
            getInvestmentDetails.map((plan) => {
              if (plan.planName === "gold plan") {
                return (
                  <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12">
                    <div class="investment_box_wrapper sv_pricing_border float_left">
                      <div class="investment_icon_circle">
                        <i class="flaticon-movie-tickets"></i>
                      </div>
                      <div class="investment_border_wrapper"></div>
                      <div class="investment_content_wrapper">
                        <h1>
                          <a href="#">{plan.planName}</a>
                        </h1>
                        <p>
                          {/* Min Amount: {"$" + plan.minAmount + ".00"}
                          <br />
                          Max Amount : {"$" + plan.max + ".00"} */}
                          <br /> {plan.intrestTag}
                          {/* <br /> Principal Return
                          <br /> Compound Available */}
                        </p>
                      </div>
                      <div class="about_btn plans_btn">
                        <ul>
                          <li>
                            <a
                              onClick={() => handlePlanChoose(plan)}
                              style={{ color: "white" }}
                            >
                              choose plan
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                );
              } else if (plan.planName === "copper plan") {
                return (
                  <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12">
                    <div class="investment_box_wrapper sv_pricing_border float_left">
                      <div class="investment_icon_circle red_info_circle">
                        <i class="flaticon-invoice"></i>
                      </div>
                      <div class="investment_border_wrapper red_border_wrapper"></div>
                      <div class="investment_content_wrapper red_content_wrapper">
                        <h1>
                          <a href="#">{plan.planName}</a>
                        </h1>
                        <p>
                          {/* Min Amount: {"$" + plan.minAmount + ".00"}
                          <br />
                          Max Amount : {"$" + plan.maxAmount + ".00"} */}
                          <br /> {plan.intrestTag}
                          {/* <br /> Principal Return
                          <br /> Compound Available */}
                        </p>
                      </div>
                      <div class="about_btn plans_btn red_btn_plans">
                        <ul>
                          <li>
                            <a
                              onClick={() => handlePlanChoose(plan)}
                              style={{ color: "white" }}
                            >
                              choose plan
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                );
              } else if (plan.planName === "bronze plan") {
                return (
                  <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12">
                    <div class="investment_box_wrapper sv_pricing_border float_left">
                      <div class="investment_icon_circle blue_icon_circle">
                        <i class="flaticon-progress-report"></i>
                      </div>
                      <div class="investment_border_wrapper blue_border_wrapper"></div>
                      <div class="investment_content_wrapper blue_content_wrapper">
                        <h1>
                          <a href="#">{plan.planName}</a>
                        </h1>
                        <p>
                          {/* Min Amount: {"$" + plan.minAmount + ".00"}
                          <br />
                          Max Amount : {"$" + plan.maxAmount + ".00"} */}
                          <br /> {plan.intrestTag}
                          {/* <br /> Principal Return
                          <br /> Compound Available */}
                        </p>
                      </div>
                      <div class="about_btn plans_btn blue_btn_plans">
                        <ul>
                          <li>
                            <a
                              onClick={() => handlePlanChoose(plan)}
                              style={{ color: "white" }}
                            >
                              choose plan
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                );
              } else if (plan.planName === "silver plan") {
                return (
                  <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12">
                    <div class="investment_box_wrapper sv_pricing_border float_left">
                      <div class="investment_icon_circle green_info_circle">
                        <i class="flaticon-file"></i>
                      </div>
                      <div class="investment_border_wrapper green_border_wrapper"></div>
                      <div class="investment_content_wrapper green_content_wrapper">
                        <h1>
                          <a href="#">{plan.planName}</a>
                        </h1>
                        <p>
                          {/* Min Amount: {"$" + plan.minAmount + ".00"}
                          <br />
                          Max Amount : {"$" + plan.maxAmount + ".00"} */}
                          <br /> {plan.intrestTag}
                          {/* <br /> Principal Return
                          <br /> Compound Available */}
                        </p>
                      </div>
                      <div class="about_btn plans_btn green_plan_btn">
                        <ul>
                          <li>
                            <a
                              onClick={() => handlePlanChoose(plan)}
                              style={{ color: "white" }}
                            >
                              choose plan
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12">
                    <div class="investment_box_wrapper sv_pricing_border float_left">
                      <div class="investment_icon_circle green_info_circle">
                        <i class="flaticon-file"></i>
                      </div>
                      <div class="investment_border_wrapper green_border_wrapper"></div>
                      <div class="investment_content_wrapper green_content_wrapper">
                        <h1>
                          <a href="#">{plan.planName}</a>
                        </h1>
                        <p>
                          {/* Min Amount: {"$" + plan.minAmount + ".00"}
                          <br />
                          Max Amount : {"$" + plan.maxAmount + ".00"} */}
                          <br /> {plan.intrestTag}
                          {/* <br /> Principal Return
                          <br /> Compound Available */}
                        </p>
                      </div>
                      <div class="about_btn plans_btn green_plan_btn">
                        <ul>
                          <li>
                            <a
                              onClick={() => handlePlanChoose(plan)}
                              style={{ color: "white" }}
                            >
                              choose plan
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                );
              }
            })
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
